import { render } from "./preview.vue?vue&type=template&id=03f96865"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/preview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03f96865"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03f96865', __exports__)) {
    api.reload('03f96865', __exports__)
  }
  
  module.hot.accept("./preview.vue?vue&type=template&id=03f96865", () => {
    api.rerender('03f96865', render)
  })

}


export default __exports__